<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nEuTt0/tc-custom/9780544105515.jpg?1700795665174" alt="This image is the cover for the book Bride of the Innisfallen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bride of the Innisfallen
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of short stories from the Pulitzer Prize–winning author of classic American southern literature. </b><br/>  <br/> Combining stories set in the rural south, Eudora Welty’s own special province, and stories with a European locale, which give a wider range to her fiction, <i>The Bride of Innisfallen </i>demonstrates the remarkable talent of one of the finest short story writers of our time.<br/>  <br/> The gentle wit of the title story, the grave and musical prose of “Circe,” a retelling of Greek myth, the acute character portrayal and extraordinary evocation of the steamy bayou county in “No Place for You, My Love” are all touched with the particular magic that has made Welty one of America’s most beloved storytellers.<br/>  <br/> “The writing throughout is at Ms. Welty’s best level.” —Edward Weeks, <i>The Atlantic</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eudora Welty
      </h2>
      
      <p class="authorDescription body article">Eudora Welty (1909&ndash;2001) was born in Jackson, Mississippi, and attended the Mississippi State College for Women, the University of Wisconsin, and Columbia University (where she studied advertising). In addition to short fiction, Welty wrote novels, novellas, essays, and reviews, and was the winner of both the National Book Award and the Pulitzer Prize.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d095e7e